<template>
  <div class="essay-view position-relative w-100">
    <eg-b-overlay :show="loading || error !== ''" no-wrap>
      <template #overlay>
        <div>
          <div v-if="loading" class="text-center">
            <eg-b-spinner class="mb-3"></eg-b-spinner>
            <p>{{ $t("common.processingRequest") }}</p>
          </div>
          <eg-b-alert v-else variant="danger" show>{{ error }}</eg-b-alert>
        </div>
      </template>
    </eg-b-overlay>
    <section v-if="essay" class="essay-view-container d-flex flex-column">
      <eg-b-alert v-if="copyError" class="mb-5" variant="danger" show>
        {{ copyError }}
      </eg-b-alert>

      <essay-page-header
        :essay="essay"
        :page-info="pageInfo"
        :get-essay="getEssay"
        @essayStatusChanged="updateStatus"
        @loadingChanged="loading = $event"
        @regradingChange="regrading = $event"
      />

      <eg-b-row v-if="regrading" class="mt-4">
        <eg-b-col>
          <div class="text-center mt-4">
            <eg-b-spinner
              variant="info"
              :label="$t('essays.regrading')"
              style="width: 64px; height: 64px"
            />
            <h2 class="mt-4">
              {{ $t("essays.regrading") }} {{ essay?.name }}...
            </h2>
          </div>
        </eg-b-col>
      </eg-b-row>
      <eg-b-row v-else class="content-wrapper h-100">
        <eg-b-overlay :show="essay.status === 'Failed'" no-wrap>
          <template #overlay>
            <div class="text-center">
              <h2 class="mt-4">
                {{ $t("essays.failedToGrade") }}
              </h2>

              <eg-b-button
                class="mr-2 text-muted"
                variant="link"
                @click="$router.push('/essays')"
              >
                <eg-b-icon
                  class="mr-0 mr-lg-2"
                  icon="arrow-left"
                  aria-hidden="true"
                />
                <span>{{ $t("essays.backToEssays") }}</span>
              </eg-b-button>
            </div>
          </template>
        </eg-b-overlay>

        <eg-splitpanes>
          <Pane min-size="20" max-size="70" size="50">
            <div
              lg="6"
              class="essay-view-details-column d-flex flex-column h-100 overflow-auto p-0"
            >
              <!-- <div class="text-right mt-1 mb-2">
            <eg-button
              size="sm"
              type="secondary"
              variant="outline-info"
              @click="showHighlight = !showHighlight"
            >
              {{ showHighlight ? "Hide" : "Show" }} Highlights
            </eg-button>
          </div> -->
              <!-- <div class="box light highlights-box"> -->
              <div class="h-100">
                <essay-content
                  :essay="essay"
                  :comments="comments"
                  :comment-loading="commentLoading"
                  :highlights="highlights"
                  :show-highlight="showHighlight"
                  :active-highlight-index="activeHighlightIndex"
                  @highlightClicked="highlightClicked"
                  @addComment="addComment"
                  @updateComment="updateComment"
                  @deleteComment="deleteComment"
                  @updateActiveHighlightIndex="activeHighlightIndex = $event"
                />
                <!-- <essay-student-submissions
              v-if="essay?.Student?.id"
              class="essay-student-submissions mt-auto pb-4 pt-3"
              :essay="essay"
              @input="onSelectStudentSubmission"
            /> -->
              </div>
            </div>
          </Pane>

          <Pane style="min-width: 40%" min-size="40" max-size="70" size="50">
            <div
              lg="6"
              class="mt-4 mt-lg-0 p-0 essay-view-details-column d-flex flex-column h-100 overflow-auto w-full"
            >
              <h2 class="heading-s title">{{ $t("essays.review") }}</h2>
              <eg-tabs
                v-model="activeTab"
                class="h-100 d-flex flex-column overflow-auto"
                content-class="h-100"
                nav-class-wrapper="mx-3"
                @input="activeHighlightIndex = -1"
              >
                <eg-b-tab :title="$t('essays.feedbackReport')" lazy>
                  <feedback-report-v3
                    v-if="isV3"
                    :essay="essay"
                    :active-highlight-index="activeHighlightIndex"
                    @updateEssay="essay = $event"
                    @updateHighlights="highlights = $event"
                    @updateActiveHighlightIndex="activeHighlightIndex = $event"
                  />
                  <base-report-v2
                    v-else
                    type="feedback"
                    :essay="essay"
                    @updated="({ html, type }) => (essay[type] = html)"
                  />
                </eg-b-tab>
                <eg-b-tab :title="$t('essays.grammarReport')" lazy>
                  <grammar-report-v3
                    v-if="isV3"
                    :essay="essay"
                    :active-highlight-index="activeHighlightIndex"
                    @updateEssay="essay = $event"
                    @updateHighlights="highlights = $event"
                    @updateActiveHighlightIndex="activeHighlightIndex = $event"
                  />
                  <base-report-v2
                    v-else
                    type="errors"
                    :essay="essay"
                    @updated="({ html, type }) => (essay[type] = html)"
                  />
                </eg-b-tab>
                <eg-b-tab
                  :title="$t('essays.aiDetection')"
                  :active="false"
                  lazy
                >
                  <template v-if="hasAiFlag" #title>
                    <div class="d-flex align-items-center">
                      <div class="mr-2">{{ $t("essays.aiDetection") }}</div>
                      <!-- <eg-b-badge
                    v-if="flagsCount > 0"
                    class="flag-badge"
                    :class="detectedClass"
                    pill
                    variant="primary"
                  >
                    <eg-b-icon icon="flag" />
                    {{ flagsCount }} Detected
                  </eg-b-badge> -->
                      <eg-b-badge
                        v-if="!canGoAiDetector"
                        pill
                        variant="info-light"
                      >
                        <eg-b-icon variant="info" icon="award" />
                        Pro
                      </eg-b-badge>
                    </div>
                  </template>
                  <essay-flags
                    :essay="essay"
                    :active-highlight-index="activeHighlightIndex"
                    @updateEssay="essay = $event"
                    @updateHighlights="highlights = $event"
                    @updateActiveHighlightIndex="activeHighlightIndex = $event"
                  />
                </eg-b-tab>
                <eg-b-tab
                  :title="$t('essays.plagiarism')"
                  lazy
                  @click="refreshEssayFlags"
                >
                  <essay-tab-plagiarism
                    :essay="essay"
                    :active-highlight-index="activeHighlightIndex"
                    @updateEssay="essay = $event"
                    @updateHighlights="highlights = $event"
                    @updateActiveHighlightIndex="activeHighlightIndex = $event"
                  />
                </eg-b-tab>
                <eg-b-tab
                  class="h-100"
                  :title="$t('essays.comments')"
                  lazy
                  @click="() => getEssayComments()"
                >
                  <essay-tab-comments
                    :comments="comments"
                    :comment-loading="commentLoading"
                    :active-highlight-index="activeHighlightIndex"
                    @updateHighlights="highlights = $event"
                    @updateActiveHighlightIndex="activeHighlightIndex = $event"
                    @updateComment="updateComment"
                    @deleteComment="deleteComment"
                  />
                </eg-b-tab>
              </eg-tabs>
            </div>
          </Pane>
        </eg-splitpanes>
      </eg-b-row>

      <move-essay-modal
        :essay-id="essay?.id"
        @essayMoved="redirectToEssays"
        @moveError="setMoveError"
      />
      <!-- <essay-regrade-modal
        :essay="essay"
        :essay-id="essay?.id"
        @startRegrade="regrading = true"
        @finishRegrade="regrading = false"
      /> -->

      <export-to-classroom-modal
        :selected-essays="[essay]"
        @essays-exported="onEssaysExported"
      />
      <export-to-canvas-modal
        :selected-essays="[essay]"
        @essays-exported="onEssaysExported"
      />

      <export-to-pdf :selected-ids="[essay.id]" />
      <export-to-csv :selected-ids="[essay.id]" />

      <essay-rename-modal :essay="essay" @updated="getEssay" />
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import { getEssay, getEssayFlags } from "@/api";
import EssayPageHeader from "@/components/essay/essay/essay_page_header.vue";
import MoveEssayModal from "@/components/essay/modals/move_essay_modal.vue";
import ExportToClassroomModal from "@/components/essay/modals/export_to_classroom.vue";
import ExportToCanvasModal from "@/components/essay/modals/export_to_canvas.vue";
import ExportToPdf from "@/components/essay/modals/export_to_pdf.vue";
import ExportToCsv from "@/components/essay/modals/export_to_csv.vue";
import EssayRenameModal from "@/components/essay/modals/essay_rename_modal.vue";
import EssayContent from "@/components/essay/essay/essay_content.vue";
import BaseReportV2 from "@/components/essay/essay/base_report_v2.vue";
import EssayFlags from "@/components/essay/essay/flags/essay_flags.vue";
import EssayTabComments from "@/components/essay/essay/essay_tab_comments.vue";
import EssayTabPlagiarism from "@/components/essay/essay/essay_tab_plagiarism.vue";
// import FlagCloseToGradeV3 from "@/components/essay/essay/flags/v3/flag_close_to_grade_v3.vue";
import FeedbackReportV3 from "@/components/essay/essay/v3/feedback_report_v3.vue";
import GrammarReportV3 from "@/components/essay/essay/v3/grammar_report_v3.vue";
import commentsMixin from "@/components/essay/comments/mixins/commentsMixin";
import EgSplitpanes from "@/components/global/eg_splitpanes.vue";

export default {
  name: "EssayView",

  components: {
    BaseReportV2,
    MoveEssayModal,
    ExportToClassroomModal,
    ExportToCanvasModal,
    ExportToPdf,
    ExportToCsv,
    EssayRenameModal,
    EssayFlags,
    EssayContent,
    EssayPageHeader,
    EssayTabComments,
    EssayTabPlagiarism,
    // FlagCloseToGradeV3,
    FeedbackReportV3,
    GrammarReportV3,
    EgSplitpanes,
  },

  mixins: [commentsMixin],

  data() {
    return {
      activeTab: 0,
      regrading: false,
      loading: true,
      error: "",
      essay: null,
      pageInfo: null,
      copyError: "",
      showHighlight: true,

      highlights: [],
      activeHighlightIndex: -1,
    };
  },

  computed: {
    ...mapGetters("config", ["features"]),

    isV3() {
      return (this.essay?.tags || []).includes("v3");
    },

    routerIdParam() {
      return this.$route.params.essayId;
    },

    canGoAiDetector() {
      return this.$store.getters.userIsNotPausedAndPlanMoreThenPro;
    },

    /*  flagsCount() {
      return (this.essay?.flags || []).length;
    },*/

    hasAiFlag() {
      return (this.essay?.flags || []).some((item) => item.type === "usedAI");
    },

    closeToGradeFlag() {
      const isHidden = (this.features?.hiddenTabsEssayView || []).includes(
        "closeToGrade"
      );
      if (isHidden) return null;

      return (this.essay?.flags || []).find(
        (flag) => flag.type === "closeToGrade"
      );
    },

    /*   detectedClass() {
      switch (this.flagsCount) {
        case 0:
          return "";

        case 1:
          return "yellow";

        case 2:
          return "orange";

        default:
          return "danger";
      }
    },*/
  },

  async created() {
    await this.getEssay();
    if (this.$route.name !== "workspace-essay-view" && this.essay.folder) {
      await this.$router.push({
        name: "workspace-essay-view",
        params: {
          workspaceKey: this.essay.folder.platform,
          id: this.essay.folder.id,
          essayId: this.essay.id,
        },
        query: this.$route.query,
      });
    }
    this.activeTab = parseInt(this.$route.query.tab) || 0;
  },

  methods: {
    ...mapActions(["setAiDetectorEssayContent"]),

    async highlightClicked(highlight) {
      if (!highlight.refComponent) {
        throw new Error(
          "highlight should has refComponent - link to vue component"
        );
      }

      await this.$nextTick();
      const element = highlight.refComponent?.$el || highlight.refComponent;
      element?.scrollIntoView({ behavior: "smooth" });
      this.activeHighlightIndex = highlight.highlightIndex - 1;
    },

    async getEssay(params = {}) {
      try {
        // NOTE: No Promise.all because in the first request (getEssay) we get essay 'before'/'after' (in params) this.routerIdParam,
        // then we get flags for this next/prev essay
        const { data } = await getEssay(this.routerIdParam, params);
        const essayId = data.essay?.id;

        const [essayFlags] = await Promise.all([
          getEssayFlags(essayId),
          this.getEssayComments(essayId),
        ]);

        const {
          data: { flags },
        } = essayFlags;

        this.essay = Object.assign(data.essay, { flags });
        this.pageInfo = {
          ...data.pageInfo,
          current: data.current,
          totalCount: data.totalCount,
        };

        this.loading = false;
        this.error = "";
      } catch (error) {
        this.loading = false;
        this.error = error.response?.data?.error;
      }
    },

    async refreshEssayFlags() {
      if (!this.essay?.id) return;

      try {
        const {
          data: { flags },
        } = await getEssayFlags(this.essay.id);

        this.essay = Object.assign(this.essay, { flags });
      } catch (error) {
        console.error("Failed to refresh essay flags:", error);
      }
    },

    redirectToEssays() {
      this.$router.push("/essays?moved=true");
    },

    setMoveError(error) {
      this.error = error;
    },

    showUpgradeModal() {
      this.$bvModal.show("upgrade-modal");
    },

    updateStatus(status) {
      this.essay.status = status;
    },

    onEssaysExported() {
      this.getEssay();
    },

    // onSelectStudentSubmission(essay) {
    //   this.$router.push(`/essay/compare/${this.essay.id}/${essay.id}`);
    // },
  },
};
</script>

<style scoped lang="scss">
.essay-view {
  // 48px is the top and bottom container margin on App.vue
  /*min-height: calc(100vh - var(--navbar-height) - 48px);*/
  height: 100%;

  .w-full {
    width: 100%;
  }
}
.essay-view-container {
  height: 100%;
}
.highlights-box {
  max-height: calc(100vh - 344px - var(--maintenance-height));
  overflow: auto;
}

.box {
  white-space: pre-wrap;
  // padding: 25px;
  border-radius: 7px;
  border: 1px solid rgba(0, 0, 0, 0.125);
  height: 100%;
  display: flex;
  flex-direction: column;
  padding: 25px 25px 0;
}

.title {
  color: var(--color-text-neutral-on-white, #1c0f30);
  font-feature-settings: "liga" off, "clig" off;

  /* Heading/S : 20px SemiBold */
  font-family: var(--typography-font-family-text-primary, Inter);
  font-size: var(--typography-font-size-fs-600, 20px);
  font-style: normal;
  font-weight: var(--typography-font-weight-fw-600, 600);
  line-height: 120%; /* 24px */
  display: flex;
  padding: 24px 24px 12px 24px;
  /* justify-content: center; */
  /* align-items: center; */
  gap: 8px;
  /* align-self: stretch; */
  margin: 0 !important;
  color: var(--color-text-neutral-on-white, #1c0f30);
  font-feature-settings: "liga" off, "clig" off;
  font-family: var(--typography-font-family-text-primary, Inter);
  font-size: var(--typography-font-size-fs-600, 20px);
  font-style: normal;
  font-weight: var(--typography-font-weight-fw-600, 600);
  line-height: 120%;
}

.flag-badge {
  display: none;

  &.yellow {
    display: block;
    background-color: hsla(45, 100%, 85%, 0.6);
    color: var(--Text---Low, hsl(45, 74%, 36%));
  }

  &.orange {
    display: block;
    background-color: hsla(30, 88%, 55%, 0.35);
    color: hsla(30, 70%, 41%, 1);
  }

  &.danger {
    display: block;
    background: var(--Danger-bg, hsl(354, 100%, 96%));
    color: hsla(354, 63%, 47%, 1);
  }
}
.essay-student-submissions {
  position: sticky;
  bottom: 0;
  background: white;
}

@media (max-width: 1210px) {
  ::v-deep .essay-view-details-column .nav-link {
    padding: 0.5rem 0.4rem;
  }
}

@media (max-width: 1060px) {
  ::v-deep .essay-view-details-column .nav-link {
    padding: 0.5rem 0.35rem;
  }
  .essay-view-details-column {
    padding-left: 5px;
    padding-right: 5px;
  }
}

.essay-view-container {
  padding: 0 15px;
  overflow: auto;
}

.content-wrapper {
  background: white;
  overflow: auto;
}

.eg-tabs::v-deep {
  .eg-tabs__container .eg-tabs__nav {
    padding: 0 8px;
  }
}

.essay-view-details-column {
  background-color: white;
}
</style>

<style lang="scss">
.folders-provider.single-essay-page .wrapper .content {
  padding: 0;
  background: white;
}
@media (max-width: 1210px) {
  .essay-view-details-column .btn.btn-sm {
    line-height: 0.1rem;
    min-height: 1.94rem;
  }
}

@media print {
  .essay-view {
    .essay-title {
      max-width: 100%;
    }
  }
}
</style>
